import axios from '../axios';

import type { Track } from '../interfaces/track';
import type { Album } from '../interfaces/albums';
import type { Artist } from '../interfaces/artist';
import type { Pagination } from '../interfaces/api';
import { mapJioSaavnArtistToSpotifyArtist, mapJioSaavnAlbumToSpotifyAlbum, mapJioSaavnSongToSpotifyTrack } from '../utils/jiosaavn-adapters';

const fetchArtist = async (id: string) => {
  const res = await axios.get<any>(`/artists`, { params: { id } });
  const data = res.data?.data || {};
  return { data: mapJioSaavnArtistToSpotifyArtist(data) };
};

const fetchArtists = async (ids: string[]) => {
  const responses = await Promise.all(ids.map((id) => axios.get<any>(`/artists`, { params: { id } })));
  return { data: { artists: responses.map((r) => mapJioSaavnArtistToSpotifyArtist(r.data?.data || {})) } };
};

const fetchArtistAlbums = async (id: string, params: any = {}) => {
  const limit = params.limit || 10;
  const offset = params.offset || 0;
  const page = Math.floor(offset / limit);
  const res = await axios.get<any>(`/artists/${id}/albums`, { params: { page } });
  const items = (res.data?.data?.albums || []).map(mapJioSaavnAlbumToSpotifyAlbum);
  return { data: { href: '', items, limit, offset, total: res.data?.data?.total || 100, previous: null, next: null } as unknown as Pagination<Album> };
};

const fetchArtistTopTracks = async (id: string, page: number = 0) => {
  // If page > 0, fallback to paginated songs (so Radio page can fetch more), otherwise get the curated top songs
  if (page > 0) {
    const res = await axios.get<any>(`/artists/${id}/songs`, { params: { page } });
    const tracks = (res.data?.data?.songs || []).map(mapJioSaavnSongToSpotifyTrack);
    return { data: { tracks } };
  }
  const res = await axios.get<any>(`/artists/${id}/top`);
  const tracks = (res.data?.data || []).map(mapJioSaavnSongToSpotifyTrack);
  return { data: { tracks } };
};

const fetchSimilarArtists = async (id: string): Promise<{ data: { artists: Artist[] } }> => {
  const res = await axios.get<any>(`/artists`, { params: { id } });
  const similar = res.data?.data?.similarArtists || [];
  return { data: { artists: similar.map(mapJioSaavnArtistToSpotifyArtist) } };
};

export const artistService = {
  fetchArtist,
  fetchArtists,
  fetchArtistAlbums,
  fetchArtistTopTracks,
  fetchSimilarArtists,
};
